import React from 'react';
import {formatDate} from "../utils";
import MomentUtils from '@date-io/moment';
import { TextField, InputAdornment } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';

import {
    DatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

const todayIsPicked = (datePickerDate) => {

    const date = new Date(datePickerDate);
    const now = new Date();

    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    now.setMilliseconds(0);

    return now.getTime() === date.getTime();
}

const DeliveryDatePicker = ({
    inputClassName,
    textFieldClassName,
    setFieldValue = () => {},
    value,
    error,
    helperText = ''
}) => {
    const [isDatePickerOpen, setIsDatePickerOpen] = React.useState(false);

    return (
        <>
            <TextField
                className={textFieldClassName}
                variant="filled"
                fullWidth={true}
                label="Delivery date"
                disabled={true}
                value={(value && !todayIsPicked(value))  ? formatDate(value, 'M d, Y', false) : 'Now'}
                onClick={() => {
                    setIsDatePickerOpen(true);
                }}
                InputProps={{
                    endAdornment: <InputAdornment position="end"><EventIcon /></InputAdornment>,
                    variant: 'filled',
                    className: inputClassName
                }}
            />
            <div style={{display: 'none'}}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <DatePicker

                        open={isDatePickerOpen}
                        onOpen={() => setIsDatePickerOpen(true)}
                        onClose={() => {
                            setIsDatePickerOpen(false);
                        }}

                        onChange={(response) => {
                            if (todayIsPicked(response)) {
                                setFieldValue('deliveryDate', {_d: null});
                                return;
                            }
                            setFieldValue('deliveryDate', response);
                        }}
                        value={value}
                        name="deliveryDate"
                        maxDate={(new Date()).setMonth((new Date()).getMonth() + 6)}
                        inputVariant="filled"
                        disablePast
                        format="MMM DD, YYYY"
                        fullWidth
                        label="Delivery date"
                        InputProps={{
                            endAdornment: <InputAdornment position="end"><EventIcon /></InputAdornment>,
                            variant: 'filled',
                            className: `${inputClassName} ${textFieldClassName}`
                        }}
                        error={error}
                        helperText={helperText}
                    />
                </MuiPickersUtilsProvider>
            </div>
        </>
    )

};

export default DeliveryDatePicker;